export default "__VITE_ASSET__CZlZ9nnx__"